
const storeState = {
  marker: null,
  administrativeDivision: null,
  searchQuery: null,
};

const getters = {
};

const actions = {
  clearMarker({ commit }) {
    commit('setMarker', null);
  },
  clearAdministrativeDivision({ commit }) {
    commit('setAdministrativeDivision', null);
  },
};

const mutations = {
  setMarker(state, payload) {
    state.marker = payload;
  },
  setAdministrativeDivision(state, payload) {
    state.administrativeDivision = payload;
  },
  setSearchQuery(state, payload) {
    state.searchQuery = payload;
  },
};


export default {
  namespaced: true,
  state: storeState,
  getters,
  actions,
  mutations,
};
